<section class="flex flex-col min-h-screen">
  <app-attendee-header class="sticky z-10 top-0 left-0"></app-attendee-header>

  <main>
    <div *ngIf="backLink" class="flex mb-3 px-0">
      <app-back-link
        [backLink]="backLink"
        [ariaLabel]="backLinkAriaLabel"
        [enableHistoryNavigation]="true"
      ></app-back-link>
    </div>

    <ng-content></ng-content>
  </main>

  <app-attendee-footer class="mt-auto"></app-attendee-footer>
</section>
